import { jsx } from 'react/jsx-runtime';

const Electric = ({ size, className }) => (jsx("svg", { className: className, fill: "none", height: size, viewBox: "0 0 20 20", width: size, xmlns: "http://www.w3.org/2000/svg", children: jsx("g", { id: "electric-icons", children: jsx("path", { d: "M8.67333 18L15.2857 8.54563H10.8775L11.6124 2L5 11.455H9.40826L8.67333 18Z", id: "Vector", stroke: "#333333", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "0.9" }) }) }));

export { Electric as E };
//# sourceMappingURL=component-DvuQZozF.js.map
